import { createSlice } from '@reduxjs/toolkit';
import type { FranchiseInitialStateInterface } from '.';

export const FRANCHISE_INITIAL_STATE: FranchiseInitialStateInterface = {
  isFareModalVisible: false,
  fareToShow: null,
  fareIdToShow: '',
};

export const franchiseSlice = createSlice({
  name: 'franchise',
  initialState: FRANCHISE_INITIAL_STATE,
  reducers: {
    setFareIdToShow: (state, action) => {
      state.fareIdToShow = action.payload;
    },
    showFranchiseModal: (state, action) => {
      state.isFareModalVisible = true;
      state.fareToShow = action.payload;
    },
    hideFranchiseModal: state => {
      state.isFareModalVisible = false;
      state.fareToShow = null;
    },
  },
});

export const { showFranchiseModal, hideFranchiseModal, setFareIdToShow } =
  franchiseSlice.actions;

export const franchiseReducer = franchiseSlice.reducer;
